import * as api from "app/api/planning"
import { SagaIterator } from "redux-saga"
import { call, put, takeLatest } from "redux-saga/effects"
import * as actions from "./balanceHoursCorrections.actions"
import * as balanceHoursActions from "../balanceHours/balanceHours.actions"
import { handleError } from "../errorHandler/errorHandler.saga"

export function* postBalanceHoursCorrectionFlow(action: actions.PostBalanceHoursCorrectionsAction): SagaIterator {
  try {
    const { employeeId, ...data } = action.payload
    yield call(api.postBalanceHoursCorrection, employeeId, data)
    yield put(actions.postBalanceHoursCorrectionsSuccess())
    const response = yield call(api.getBalanceHours, employeeId, { comparison: "<=" })
    yield put(balanceHoursActions.getBalanceHoursSuccess(response?.data))
    const estimatedResponse = yield call(api.getBalanceHours, employeeId, { limit: 1 })
    yield put(balanceHoursActions.getEstimatedBalanceHoursSuccess(estimatedResponse?.data))
  } catch (e) {
    yield put(actions.postBalanceHoursCorrectionsFail(e))
    yield call(handleError, { error: e })
  }
}

export function* getBalanceHoursCorrectionsFlow(action: actions.GetBalanceHoursCorrectionsAction): SagaIterator {
  try {
    const {
      payload: { id, params },
    } = action.payload
    const response = yield call(api.getBalanceHoursCorrections, id, params)
    yield put(actions.getBalanceHoursCorrectionsSuccess(response && response.data))
  } catch (e) {
    yield put(actions.getBalanceHoursCorrectionsFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* balanceHoursCorrectionsSaga(): SagaIterator {
  yield takeLatest(actions.Types.POST, postBalanceHoursCorrectionFlow)
  yield takeLatest(actions.Types.GET, getBalanceHoursCorrectionsFlow)
}
